<template>
  <footer
    class="page-footer"
    :style="footerStyle"
  >
    <div class="page-footer__center lg5 md4">
      <router-link
        to="/terms-and-conditions"
        class="page-footer__terms-link"
        :style="termsStyle"
      >
        Terms and Conditions
      </router-link>
    </div>
    <div class="page-footer__text page-footer__center">
      &copy; {{currentYear}} Rewarding Dog Training, LLC
    </div>
  </footer>
</template>

<script>
import moment from 'moment'

export default {
  name: 'page-footer',
  data () {
    return {
      currentYear: moment().format('YYYY'),
    }
  },
  computed: {
    footerStyle () {
      const style = {
        backgroundColor: 'white',
        color: this.$themes.darkerGray,
        'border-top': `1px solid ${this.$themes.lighterGray}`,
      }
      return style
    },
    termsStyle () {
      const style = {
        '--color': this.$themes.fontColor,
        '--color-hover': this.$themes.primary,
      }
      return style
    },
  },
}
</script>

<style lang="scss">
.page-footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100vw;
  transition: background-color 0.3s ease; /* sidebar's bg color transitions as well -> consistency */
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem 1rem;
  z-index: 100;

  &__center {
    display: flex;
    margin-left: 0.8rem;
    align-items: center;
  }

  // &__text {
  //   color: $gray;
  // }

  &__terms-link {
    color: var(--color);
  }

  &__terms-link:hover {
    color: var(--color-hover);
  }
}
</style>
